// Get backend API URL based on environment
export const getBackendApiUrl = () => {
  // In development mode with Vite, use empty string so proxy handles it
  // The proxy in vite.config.js forwards /api/* to http://127.0.0.1:8000
  if (import.meta.env.VITE_DEV_MODE === 'true') {
    // Return empty string - requests like /api/channels/ will be proxied by Vite
    return '';
  }
  
  // In production, use VITE_BACKEND_API_URL or construct from hostname
  const backendUrl = import.meta.env.VITE_BACKEND_API_URL;
  if (backendUrl) {
    return backendUrl;
  }
  
  // Fallback: construct URL from current hostname with port 8000
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  return `${protocol}//${hostname}:8000`;
};

export const BACKEND_API_URL = getBackendApiUrl();

